module.exports = __webpack_public_path__ + "packs/media/images/avatars/avatar-3-40c3279e98c7f278dc6559bded301a00.png";